export const dataURLtoFile = (dataurl) => {
    const arr = dataurl.split(',');
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const mime = arr[0].match(/:(.*?);/)[1];

    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], 'logo', { type: mime });
};
